import {
  CountryPreferenceCompanyDto,
  CountryPreferenceDto,
} from 'api/Clients/Types/CountryPreference'
import stringComparator from 'utils/stringComparator'

import { CountryPreference, PreferredCompany } from '../types'

export const normalizeCountries = (
  countryPreferences: CountryPreferenceDto[]
): CountryPreference[] =>
  sortCountries(
    countryPreferences.map((country) => ({
      ...country,
      preferredCompany: normalizePreferredCompany(country.companies),
      defaultPublicDomain: normalizeDefaultPublicDomain(country.companies),
    }))
  )

const normalizePreferredCompany = (companies: CountryPreferenceCompanyDto[]): PreferredCompany => {
  const preferredCompany = companies.find((company) => company.isPreferred)

  return {
    id: preferredCompany?.company?.id ?? 0,
    name: preferredCompany?.company?.name ?? '',
    shortName: preferredCompany?.company?.shortName ?? '',
  }
}

const normalizeDefaultPublicDomain = (
  companies: CountryPreferenceCompanyDto[]
): string | undefined => {
  return companies.find((company) => company.isPreferred)?.company.tickmillPublicDomain?.name
}

const sortCountries = (countryPreferences: CountryPreference[]) => {
  if (!countryPreferences) {
    return []
  }

  return [...countryPreferences].sort((a: CountryPreference, b: CountryPreference) =>
    stringComparator(a.country.name, b.country.name)
  )
}
